// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"bb66aa50","245":"a936f550","264":"655aa11f","480":"9caa74b8","638":"49a88156"}[chunkId] + ".chunk.js";
};